import { render, staticRenderFns } from "./payroll-slip.vue?vue&type=template&id=12b2427e&scoped=true&"
import script from "./payroll-slip.vue?vue&type=script&lang=js&"
export * from "./payroll-slip.vue?vue&type=script&lang=js&"
import style0 from "./payroll-slip.vue?vue&type=style&index=0&id=12b2427e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b2427e",
  null
  
)

export default component.exports